import horizontalScroll from '../modules/horizontalScroll.js';
const initBlock = function( $block ) {
	horizontalScroll( $block );
};

app.loadBlock( initBlock, 'donate', '.section-donate' );

if ( module.hot ) {
	module.hot.accept();
}
